export default function FinalCTA() {
  const scrollToContact = () => {
    const el = document.querySelector('#contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-24 md:py-32 bg-[#1A1A1A]">
      <div className="max-w-4xl mx-auto px-6 md:px-14 text-center">
        <div className="flex items-center justify-center gap-3 mb-5">
          <div className="w-8 h-px bg-[#C9A961]"></div>
          <span className="text-[#C9A961] text-xs font-semibold uppercase tracking-[0.2em]">Take the Next Step</span>
          <div className="w-8 h-px bg-[#C9A961]"></div>
        </div>
        <h2
          className="text-4xl md:text-6xl font-bold text-white mb-5 leading-tight"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          Schedule with Confidence
        </h2>
        <p className="text-white/80 text-lg mb-12 max-w-xl mx-auto leading-relaxed">
          Schedule today and get clear, professional insights before making your next property decision.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={scrollToContact}
            className="bg-[#C9A961] text-white font-semibold text-base px-10 py-4 rounded-md hover:bg-[#b8944f] transition-all duration-200 hover:-translate-y-0.5 cursor-pointer whitespace-nowrap"
          >
            Schedule Inspection
          </button>
          <a
            href="tel:+12814217355"
            className="flex items-center justify-center gap-2.5 border border-white/22 text-white font-semibold text-base px-10 py-4 rounded-md hover:border-[#C9A961]/55 hover:text-[#C9A961] transition-all duration-200 whitespace-nowrap"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-fill text-[#C9A961]"></i>
            </div>
            Call (281) 421-7355
          </a>
        </div>
      </div>
    </section>
  );
}
